import { required } from './required';
var regex = /^[^!@£$%^&*:;|\\/?<>]+$/;
export function validateName(value) {
    return !value || regex.test(value) ? null : 'Enter a valid name';
}
export var requiredName = required(validateName);
//# sourceMappingURL=validateName.js.map